import { PatientStatus, QueryFactory } from '@lmt/shared-types';
import {
  pagingQueryParams,
  sortingQueryParams,
  toQueryParams,
} from '@lmt/unicorn-shared/app/components/common/table/operations';
import { PatientList } from '@lmt/unicorn-shared/app/components/patients/list/components/PatientList';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import { useQueryParamsInTab } from '@lmt/unicorn-shared/app/helpers/use-query-params-in-tab';
import React, { FC } from 'react';
import styles from './PatientExtendedSearch.module.scss';
import { TablePagination } from '../../common/table/TablePagination';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { PageSize } from '../../common/table/types';

interface Props {
  searchString: string;
}

export const PatientExtendedSearch: FC<Props> = React.memo(
  function PatientExtendedSearch(props) {
    const [queryParams, setQueryParams] = useQueryParamsInTab({
      ...pagingQueryParams(PageSize.Small),
      ...sortingQueryParams(),
    });
    const claims = useClaims();
    const i18next = useScopedTranslation('patients.list');
    const patientsQuery = QueryFactory.PatientQuery.useGetPatientsQuery({
      searchQuery: props.searchString,
      statuses: [PatientStatus.Active, PatientStatus.Deceased],
      states: null,
      ...toQueryParams(queryParams),
    });

    return (
      <div className={styles.tableContainer}>
        <PatientList
          patients={patientsQuery.data?.data ?? []}
          setSorting={setQueryParams}
          isLoading={patientsQuery.isLoading}
          isFiltered={true}
        />
        <div>
          <TablePagination
            pagination={queryParams}
            pageLimitTitle={i18next.t('pagination_page_limit')}
            changePagination={setQueryParams}
            totalCount={patientsQuery.data?.totalCount}
          />
        </div>
      </div>
    );
  },
);
